module.exports = __webpack_public_path__ + "static/media/icon-fullscreen-contract.b5e6547e.svg";